import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Home, ChevronDown, Search, Menu, X } from 'lucide-react';
import { Button } from '../ui/button';
import bluekraftLogo from '../../assets/bluekraftlogo.png';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const navigation = [
    { name: 'Home', path: '/', icon: Home },
    {
      name: 'Why BluekraftMed ?',
      path: '/about',
      dropdown: [
        { name: 'About Us', path: '/about' },
        { name: 'Our Edge', path: '/our-edge' },
      ],
    },
    {
      name: 'Talent Acquisition & Staffing',
      path: '/services',
      dropdown: [
        { name: 'Staffing Solutions', path: '/services#staffing' },
        { name: 'Physicians & Advanced Practice', path: '/physicians-advanced' },
        { name: 'Locum Tenens', path: '/services#locum' },
        { name: 'Telehealth', path: '/telehealth' },
      ],
    },
    { name: 'Nursing', path: '/nursing' },
    { name: 'Our Edge', path: '/our-edge' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img
                src={bluekraftLogo}
                alt="BluekraftMed Logo"
                className="h-12 w-auto"
              />
            </Link>

            {/* Contact Info */}
            <div className="hidden md:flex items-center space-x-8">
              <div className="flex items-center space-x-2">
                <Phone className="w-5 h-5 text-cyan-600" />
                <div>
                  <p className="text-sm text-gray-500">Phone:</p>
                  <p className="font-semibold text-gray-800">+1 (469)-466-2313</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-cyan-600" />
                <div>
                  <p className="text-sm text-gray-500">Email:</p>
                  <p className="font-semibold text-gray-800"><a href='mailto:info@bluekraftmed.com' target="_blank">info@bluekraftmed.com</a></p>
                </div>
              </div>

            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-gray-800"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div >

      {/* Navigation */}
      < nav className="bg-cyan-600" >
        <div className="container mx-auto px-4">
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center justify-between">
            <div className="flex items-center space-x-1">
              {navigation.map((item, index) => (
                <div
                  key={index}
                  className="relative group"
                  onMouseEnter={() => item.dropdown && setActiveDropdown(index)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <Link
                    to={item.path}
                    className={`flex items-center space-x-1 px-4 py-4 text-white hover:bg-cyan-700 transition-colors ${isActive(item.path) ? 'bg-cyan-700' : ''
                      }`}
                  >
                    {item.icon && <item.icon className="w-4 h-4" />}
                    <span>{item.name}</span>
                    {item.dropdown && <ChevronDown className="w-4 h-4" />}
                  </Link>

                  {/* Dropdown Menu */}
                  {item.dropdown && activeDropdown === index && (
                    <div className="absolute top-full left-0 bg-white shadow-lg rounded-b-lg py-2 min-w-64 z-50">
                      {item.dropdown.map((dropItem, dropIndex) => (
                        <Link
                          key={dropIndex}
                          to={dropItem.path}
                          className="block px-4 py-3 text-gray-700 hover:bg-cyan-50 hover:text-cyan-600 transition-colors"
                        >
                          {dropItem.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <button className="text-white p-4 hover:bg-cyan-700">
              <Search className="w-5 h-5" />
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4">
              {navigation.map((item, index) => (
                <div key={index}>
                  <Link
                    to={item.path}
                    className="block px-4 py-3 text-white hover:bg-cyan-700"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                  {item.dropdown && (
                    <div className="pl-8">
                      {item.dropdown.map((dropItem, dropIndex) => (
                        <Link
                          key={dropIndex}
                          to={dropItem.path}
                          className="block px-4 py-2 text-white text-sm hover:bg-cyan-700"
                          onClick={() => setMobileMenuOpen(false)}
                        >
                          {dropItem.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </nav >
    </header >
  );
};

export default Header;